import { Inject, Injectable, InjectionToken } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';
import { Observable, of } from 'rxjs';

import { APP_STORAGE } from '~/app.token';
import { UserService } from '~/auth/services/user/user.service';
import { ACTIVITIES_BASE_URL } from '~/core/core.module';

import { AbstractAuthProvider } from './abstract-auth.provider';

export const FED_OAUTH_SERVICE = new InjectionToken<string>(
  'FED OAuth service instance'
);

export const FED_ISSUER = new InjectionToken<string>('FED Issuer');
export const FED_CLIENT_ID = new InjectionToken<string>('FED client_id');
export const FED_REDIRECT_URI = new InjectionToken<string>('FED redirect uri');
export const FED_DISCOVERY_DOCUMENT = new InjectionToken<string>(
  'FED discovery document'
);

@Injectable({
  providedIn: 'root',
})
export class FedProvider extends AbstractAuthProvider {
  constructor(
    protected readonly oAuthService: OAuthService,

    @Inject(FED_ISSUER)
    issuer: string,

    @Inject(FED_CLIENT_ID)
    clientId: string,

    @Inject(FED_REDIRECT_URI)
    redirectUri: string,

    @Inject(FED_DISCOVERY_DOCUMENT)
    discoveryDocument: string,

    @Inject(ACTIVITIES_BASE_URL)
    activitiesUrl: string,

    userService: UserService,

    @Inject(APP_STORAGE) storage: Storage,
    protected readonly translateService: TranslateService
  ) {
    super(
      oAuthService,
      userService,
      {
        issuer,
        redirectUri,
        clientId,
        responseType: 'code',
        userinfoEndpoint: `${activitiesUrl}/me`,
      },
      discoveryDocument,
      storage,
      translateService
    );
  }

  protected getScopes(): Observable<string[]> {
    return of(['openid', 'profile']);
  }

  public logout(): Promise<OAuthSuccessEvent> {
    const promise = super.logout();
    window.location.href = '/';
    return promise;
  }

  public tryLogin(): Promise<boolean> {
    this.oAuthService.events.subscribe((event) => {
      if (event.type === 'token_received') {
        const state = decodeURIComponent(this.oAuthService.state);

        this.processState(state);
      }
    });

    return this.oAuthService
      .tryLoginCodeFlow({
        preventClearHashAfterLogin: true,
      })
      .then((_) => this.oAuthService.hasValidAccessToken());
  }
}
